import { cn } from '../../lib/utils';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ListRoot = ({ children, className, ...props }: { children: React.ReactNode } & React.HTMLAttributes<HTMLUListElement>) => {
    return <ul className={cn('flex flex-col gap-2', className)}>{children}</ul>;
};

const ListItem = ({
    className,
    label,
    labelClassName,
    value,
    valueClassName,
    childrenAsValue,
}: {
    className?: string;
    label: string;
    labelClassName?: string;
    value?: string | number;
    valueClassName?: string;
    childrenAsValue?: React.ReactNode;
}) => {
    return (
        <li className={cn('flex justify-between gap-6', className)} key={label + value}>
            <span className={cn('text-base font-bold', labelClassName)}>{label}</span>
            <span className={cn('text-base text-right break-all', valueClassName)}>{childrenAsValue ? childrenAsValue : value ? value : ''}</span>
        </li>
    );
};

const CheckItem = ({ label, value }: { label: string; value: boolean }) => {
    return (
        <li className="flex justify-between gap-6" key={label + value}>
            <span className={`text-base font-bold break-words ${value ? 'text-red-700' : ''}`}>{label}</span>
            <span className="text-base text-right">
                {value ? (
                    <span className="text-red-700">
                        <FontAwesomeIcon icon={faXmark} />
                    </span>
                ) : (
                    <span className="text-primary">
                        <FontAwesomeIcon icon={faCheck} />
                    </span>
                )}
            </span>
        </li>
    );
};

const LinkItem = ({ title, label, href }: { title: string; label: string; href: string }) => {
    return (
        <li className="flex justify-between gap-6" key={title}>
            <span className="text-base font-bold">{title}</span>
            <a href={href} target="_blank" rel="noreferrer" className="text-base text-right underline break-all">
                {label}
            </a>
        </li>
    );
};

export const List = Object.assign(ListRoot, {
    Item: ListItem,
    CheckItem,
    LinkItem,
});
